// Auto-generated by scripts/generate-registry.mjs — DO NOT EDIT MANUALLY!

import type { ModuleSchema } from './types.js';
import { aa_aaa_battery_tray } from './aa-aaa-battery-tray.js';
import { ai_e27_design_demo } from './ai-e27-design-demo.js';
import { bambu_led_base } from './bambu-led-base.js';
import { bambu_ribbed_pumpkin_lamp } from './bambu-ribbed-pumpkin-lamp.js';
import { chess_medals } from './chess-medals.js';
import { chess_medals_round } from './chess-medals-round.js';
import { core_badge_hanger_loop } from './core-badge-hanger-loop.js';
import { core_badge_plate } from './core-badge-plate.js';
import { core_bambu_led_cap } from './core-bambu-led-cap.js';
import { core_bambu_led_socket } from './core-bambu-led-socket.js';
import { core_bambu_screws } from './core-bambu-screws.js';
import { core_bambu_shade } from './core-bambu-shade.js';
import { core_bambu_vase_shade } from './core-bambu-vase-shade.js';
import { core_bead_cord_bore } from './core-bead-cord-bore.js';
import { core_chess_pieces } from './core-chess-pieces.js';
import { core_contour_offset_frame } from './core-contour-offset-frame.js';
import { core_e27_base } from './core-e27-base.js';
import { core_e27_ring } from './core-e27-ring.js';
import { core_e27_shade } from './core-e27-shade.js';
import { core_e27_threaded_base } from './core-e27-threaded-base.js';
import { core_e27_vase_shade } from './core-e27-vase-shade.js';
import { core_electronic_candle_base } from './core-electronic-candle-base.js';
import { core_faded_round_groove } from './core-faded-round-groove.js';
import { core_faded_square_groove } from './core-faded-square-groove.js';
import { core_flexi_pin_hinge } from './core-flexi-pin-hinge.js';
import { core_grid_hole_tray } from './core-grid-hole-tray.js';
import { core_grooved_shell } from './core-grooved-shell.js';
import { core_keycap } from './core-keycap.js';
import { core_keycap_stop_shelf } from './core-keycap-stop-shelf.js';
import { core_keychain_loop } from './core-keychain-loop.js';
import { core_key_link_hinge } from './core-key-link-hinge.js';
import { core_lamp_021_surface } from './core-lamp-021-surface.js';
import { core_mx_switch } from './core-mx-switch.js';
import { core_offset_backing } from './core-offset-backing.js';
import { core_rattan_lattice } from './core-rattan-lattice.js';
import { core_rattan_pillow_form } from './core-rattan-pillow-form.js';
import { core_rattan_pillow_solid } from './core-rattan-pillow-solid.js';
import { core_rattan_pyramid_type_a } from './core-rattan-pyramid-type-a.js';
import { core_rattan_surface } from './core-rattan-surface.js';
import { core_rattan_type_a } from './core-rattan-type-a.js';
import { core_rattan_type_b } from './core-rattan-type-b.js';
import { core_rattan_type_b_cube } from './core-rattan-type-b-cube.js';
import { core_revolved_eyelet_ring } from './core-revolved-eyelet-ring.js';
import { core_ribbed_bambu_vase_shade } from './core-ribbed-bambu-vase-shade.js';
import { core_rose_relief } from './core-rose-relief.js';
import { core_round_ribbed_shell } from './core-round-ribbed-shell.js';
import { core_slotted_c_hook } from './core-slotted-c-hook.js';
import { core_snap_joint } from './core-snap-joint.js';
import { core_solara_fluted_base } from './core-solara-fluted-base.js';
import { core_solara_fluted_shade } from './core-solara-fluted-shade.js';
import { core_spiral_vase_shade } from './core-spiral-vase-shade.js';
import { core_square_grooved_shell } from './core-square-grooved-shell.js';
import { core_square_ribbed_shell } from './core-square-ribbed-shell.js';
import { core_surface_texture_probe } from './core-surface-texture-probe.js';
import { core_svg_relief } from './core-svg-relief.js';
import { core_svg_relief_transform } from './core-svg-relief-transform.js';
import { core_text } from './core-text.js';
import { core_text_pad } from './core-text-pad.js';
import { core_threaded_collar } from './core-threaded-collar.js';
import { core_thread_column } from './core-thread-column.js';
import { core_trapezoidal_strap } from './core-trapezoidal-strap.js';
import { core_two_layer_relief } from './core-two-layer-relief.js';
import { core_waves_ambient_shade } from './core-waves-ambient-shade.js';
import { core_wavy_slotted_shade } from './core-wavy-slotted-shade.js';
import { e27_led_base } from './e27-led-base.js';
import { e27_low_base } from './e27-low-base.js';
import { essential_oil_tray } from './essential-oil-tray.js';
import { icon_bead } from './icon-bead.js';
import { keycap_clicker } from './keycap-clicker.js';
import { lamp_021 } from './lamp-021.js';
import { linked_key_chain } from './linked-key-chain.js';
import { linked_key_chain_textured } from './linked-key-chain-textured.js';
import { lipstick_screw_case } from './lipstick-screw-case.js';
import { mini_electronic_candle_lamp } from './mini-electronic-candle-lamp.js';
import { name_clicker } from './name-clicker.js';
import { notched_box_lamp } from './notched-box-lamp.js';
import { petal_glow_table_lamp } from './petal-glow-table-lamp.js';
import { pn_logo_bead } from './pn-logo-bead.js';
import { rattan_cylindrical_pen_holder_type_a } from './rattan-cylindrical-pen-holder-type-a.js';
import { rattan_hex_stand_type_a } from './rattan-hex-stand-type-a.js';
import { rattan_oval_tumbler_type_b } from './rattan-oval-tumbler-type-b.js';
import { rattan_pillow_table_lamp } from './rattan-pillow-table-lamp.js';
import { rattan_square_pen_holder_type_a } from './rattan-square-pen-holder-type-a.js';
import { rhino_wave_pillow } from './rhino-wave-pillow.js';
import { round_gem_vault } from './round-gem-vault.js';
import { solara_ambient_lamp } from './solara-ambient-lamp.js';
import { square_storage_box_slip_lid } from './square-storage-box-slip-lid.js';
import { swing_badge_keychain } from './swing-badge-keychain.js';
import { teacher_20_11_medal } from './teacher-20-11-medal.js';
import { teacher_20_11_round_medal } from './teacher-20-11-round-medal.js';
import { text_bead } from './text-bead.js';
import { text_bead_20_11 } from './text-bead-20-11.js';
import { text_bead_50 } from './text-bead-50.js';
import { text_keychain } from './text-keychain.js';
import { text_ribbon_3line } from './text-ribbon-3line.js';
import { thcs_tran_huy_lieu_clicker } from './thcs-tran-huy-lieu-clicker.js';
import { type_c_tile_relief_cup } from './type-c-tile-relief-cup.js';
import { type_d_closed_loop_cup } from './type-d-closed-loop-cup.js';
import { uach_logo_clicker } from './uach-logo-clicker.js';
import { uach_logo_clicker_square } from './uach-logo-clicker-square.js';
import { waves_ambient_lamp } from './waves-ambient-lamp.js';
import { wave_relief_pen_cup } from './wave-relief-pen-cup.js';
import { youtube_short_spiral_lamp } from './youtube-short-spiral-lamp.js';

export * from './types.js';
export { paramsFromSchema } from './params.js';
export { validateRegistry } from './validation.js';

export const MODULES: ModuleSchema[] = [
  aa_aaa_battery_tray,
  ai_e27_design_demo,
  bambu_led_base,
  bambu_ribbed_pumpkin_lamp,
  chess_medals,
  chess_medals_round,
  core_badge_hanger_loop,
  core_badge_plate,
  core_bambu_led_cap,
  core_bambu_led_socket,
  core_bambu_screws,
  core_bambu_shade,
  core_bambu_vase_shade,
  core_bead_cord_bore,
  core_chess_pieces,
  core_contour_offset_frame,
  core_e27_base,
  core_e27_ring,
  core_e27_shade,
  core_e27_threaded_base,
  core_e27_vase_shade,
  core_electronic_candle_base,
  core_faded_round_groove,
  core_faded_square_groove,
  core_flexi_pin_hinge,
  core_grid_hole_tray,
  core_grooved_shell,
  core_keycap,
  core_keycap_stop_shelf,
  core_keychain_loop,
  core_key_link_hinge,
  core_lamp_021_surface,
  core_mx_switch,
  core_offset_backing,
  core_rattan_lattice,
  core_rattan_pillow_form,
  core_rattan_pillow_solid,
  core_rattan_pyramid_type_a,
  core_rattan_surface,
  core_rattan_type_a,
  core_rattan_type_b,
  core_rattan_type_b_cube,
  core_revolved_eyelet_ring,
  core_ribbed_bambu_vase_shade,
  core_rose_relief,
  core_round_ribbed_shell,
  core_slotted_c_hook,
  core_snap_joint,
  core_solara_fluted_base,
  core_solara_fluted_shade,
  core_spiral_vase_shade,
  core_square_grooved_shell,
  core_square_ribbed_shell,
  core_surface_texture_probe,
  core_svg_relief,
  core_svg_relief_transform,
  core_text,
  core_text_pad,
  core_threaded_collar,
  core_thread_column,
  core_trapezoidal_strap,
  core_two_layer_relief,
  core_waves_ambient_shade,
  core_wavy_slotted_shade,
  e27_led_base,
  e27_low_base,
  essential_oil_tray,
  icon_bead,
  keycap_clicker,
  lamp_021,
  linked_key_chain,
  linked_key_chain_textured,
  lipstick_screw_case,
  mini_electronic_candle_lamp,
  name_clicker,
  notched_box_lamp,
  petal_glow_table_lamp,
  pn_logo_bead,
  rattan_cylindrical_pen_holder_type_a,
  rattan_hex_stand_type_a,
  rattan_oval_tumbler_type_b,
  rattan_pillow_table_lamp,
  rattan_square_pen_holder_type_a,
  rhino_wave_pillow,
  round_gem_vault,
  solara_ambient_lamp,
  square_storage_box_slip_lid,
  swing_badge_keychain,
  teacher_20_11_medal,
  teacher_20_11_round_medal,
  text_bead,
  text_bead_20_11,
  text_bead_50,
  text_keychain,
  text_ribbon_3line,
  thcs_tran_huy_lieu_clicker,
  type_c_tile_relief_cup,
  type_d_closed_loop_cup,
  uach_logo_clicker,
  uach_logo_clicker_square,
  waves_ambient_lamp,
  wave_relief_pen_cup,
  youtube_short_spiral_lamp,
];

export function getModule(id: string): ModuleSchema | undefined {
  return MODULES.find(m => m.id === id || m.uniqueId === id);
}

export async function loadModuleAsync(id: string): Promise<ModuleSchema | undefined> {
  // Registry schemas are already statically imported into MODULES for the home catalog;
  // dynamically importing them here duplicated every module and provided no code splitting.
  return getModule(id);
}

export function getDefaultModule(): ModuleSchema {
  return MODULES[0]!;
}
